export class HealthPlan {
  id: number
  idMotion: number
  name: string
  cardNumber: string | null
  cardImages?: File[] | null

  constructor(
    { id, idMotion, name, cardNumber, cardImages = null } = {} as any
  ) {
    this.id = Number(id)
    this.idMotion = Number(idMotion)
    this.name = name
    this.cardNumber = cardNumber ?? null
    this.cardImages = cardImages
  }

  get isPrivate() {
    return this.id === 15445
  }

  convertFromAlgolia(hit) {
    this.id = Number(hit.id)
    this.idMotion = Number(hit.idMotion)
    this.name = hit.name

    return this
  }

  private() {
    this.id = 15445
    this.idMotion = 7766
    this.name = 'Particular'

    return this
  }
}
